<script setup>
  import { ref, computed, onMounted, useTemplateRef } from 'vue';
  import { useResizeObserver } from '@vueuse/core';
  import Icon from "@/components/icons/Icon.vue";

  const titleElement = useTemplateRef('title-element');
  const locationElement = useTemplateRef('location-element');

  const props = defineProps({
    spot: {
      type: Object,
      required: true
    },
    isNowcastingSpot: {
      type: Boolean,
      default: false
    }
  })

  const showClipped = ref(false);
  const locationClipped = ref(false);
  const clippedAmount = ref(0);  

  const spotName = computed(() => props.isNowcastingSpot ? `${props.spot.name} <span class="jwx-page__title-tag">Nowcast</span>` : props.spot.name);
  
  const spotLocation = computed(() => {
    const locationParts = [];
    if (props.spot?.city) locationParts.push(props.spot.city);
    if (props.spot?.county) locationParts.push(props.spot.county);
    if (props.spot?.state) locationParts.push(props.spot.state);
    if (props.spot?.country) locationParts.push(props.spot.country);
    
    return locationParts.join(", ")
  });

  const hasLocation = computed(() => spotLocation.value === '' ? null : true);

  function handleShowClipped() {
    if (!locationClipped.value) return;

    showClipped.value = true;

    setTimeout(() => showClipped.value = false, 4000);
  }

  function setLocationClipped() {
    const locationElementEndPosition = locationElement.value.getBoundingClientRect().right;
    const titleElementEndPosition = titleElement.value.getBoundingClientRect().right;
    const endPositionDelta = titleElementEndPosition - locationElementEndPosition;

    locationClipped.value = endPositionDelta < 0;
    clippedAmount.value = locationClipped.value ? endPositionDelta - 16 : 0;
  }

  onMounted(() => {
    if (!locationElement.value) return;

    setLocationClipped();
  });

  useResizeObserver(locationElement, (entries) => {
    if (!locationElement.value) return;

    setLocationClipped();
  });
</script>

<template>
  <div ref="title-element" class="jwx-spot-header__title" :data-has-location="hasLocation">
    <h1 v-html="spotName" class="jwx-spot-header__spot-name"></h1>
    <div
      v-if="hasLocation"
      class="jwx-spot-header__location"
      :data-is-clipped="locationClipped"
    >
      <Icon name="location-marker" class="jwx-spot-header__location-icon" />
      <p
        ref="location-element"
        @click="handleShowClipped"
        class="jwx-spot-header__location-text"
        :class="{ 'show-clipped' : showClipped}"
        :style="`--clipped-amount: ${clippedAmount}px`"
      >
        {{ spotLocation }}
      </p>
    </div>
  </div>
</template>